import { render } from "./CargarArchivosPlaCSV.vue?vue&type=template&id=51bc922f&scoped=true"
import script from "./CargarArchivosPlaCSV.vue?vue&type=script&lang=js"
export * from "./CargarArchivosPlaCSV.vue?vue&type=script&lang=js"

import "./CargarArchivosPlaCSV.vue?vue&type=style&index=0&id=51bc922f&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51bc922f"]])

export default __exports__